import { render } from "./App.vue?vue&type=template&id=448a2688"
const script = {}

import "./App.vue?vue&type=style&index=0&id=448a2688&lang=css"
script.render = render

export default script